// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1NzvX","cell":"ColumnAccessor_cell__1cJdF","firstCellAccent":"ColumnAccessor_firstCellAccent__212uJ"};